<div class="raw main">
    <div class="col-12 reserve">
        <div class="tab">
            <label class="active">完成預約</label>
            <label routerLink="/member/history">歷史報名資料</label>
            <label routerLink="/member/edit">主要產品維護</label>
        </div>
        <p class="note">顯示採購案尚未舉辦完成之報名記錄</p>
        
        <ng-container *ngIf="Data">
            <ng-container *ngFor="let group of Data">
                <div class="list  animated fadeIn">
                    <h3><a routerLink="/activity/{{group.evt.id}}">{{group.evt.name}}</a></h3>
                    <table>
                        <tr>
                            <th class="status">
                                <label>審核狀態</label>
                            </th>
                            <th class="date">
                                <label>報名時段／桌次</label>
                            </th>
                            <th class="company">
                                <label>買主公司／國別</label>
                            </th>
                            <th class="prod">
                                <label>採購產品</label>
                            </th>
                            <th class="contact">
                               <label>報名人/參加人<i></i></label>
                            </th>
                            <th class="video">
                                <label>視訊平台<i></i></label>
                            </th>
                        </tr>
                        <ng-container *ngFor="let item of group.list">
                            <tr class="data">
                                <td class="status" data-th="審核狀態">
                                    <div>
                                        <label class="{{item.statusType.class}}">{{item.statusType.name}}</label>
                                        <div class="btn" *ngIf="item.canCancel" (click)="Cancel(item)">取消報名</div>
                                    </div>
                                </td>
                                <td class="date" data-th="報名時段／桌次">
                                    <div>
                                        <span class="day">{{item.sessionTime.desc}}</span>
                                        <!-- <span class="time">14:00-14:30</span> -->
                                        <hr>
                                        <span class="seat unset">{{(item.buyer.desk_no == '') ? '尚無桌次資訊' : item.buyer.desk_no}}</span>
                                    </div>
                                </td>
                                <td class="company" data-th="買主公司／國別">
                                    <div>
                                        <span class="name" *ngIf="item.buyer.company_url">
                                            <a href="{{item.buyer.company_url}}" target="_blank">{{item.buyer.company_name}}</a>
                                        </span>
                                        <span class="name" *ngIf="!item.buyer.company_url">{{item.buyer.company_name}}</span>
                                        <hr>
                                         <span class="contry" *ngIf="item.buyer.country">{{item.buyer.country.name}}({{item.buyer.country.continental}})</span>
                                    </div>
                                </td>
                                <td class="prod" data-th="採購產品">
                                    <div class="tags hoverEvt">
                                        <ng-container *ngFor="let prod of item.buyer.products;let _pindex = index;">
                                            <span [attr.data-desc]="prod.description" 
                                                [attr.data-spec]="prod.spec_visible"
                                                [attr.data-attach]="prod.hasAttachment"
                                                [attr.data-pid]="prod.id"
                                                [attr.data-buyer]="Data.buyer_id">{{prod.name}}</span>
                                        </ng-container>
                                    </div>
                                </td>
                                <td class="contact" data-th="報名人/參加人">
                                    <div>
                                        <select [disabled]="true" style="margin-top: 1rem;">
                                            <option value="">{{item.applierName}} {{item.applierNameEn}}</option>
                                        </select>
                                        <hr>
                                        <select [disabled]="item.status != 1" (change)="SetEvtUser($event,item)">
                                            <option value="">請選擇</option>
                                            <ng-container *ngFor="let c of contact">
                                                <option value="{{c.email}}" [selected]="c.email == item.user_id">{{c.name}} {{c.englishName}}</option>
                                            </ng-container>
                                        </select>
                                    </div>
                                </td>
                                <td class="video" data-th="視訊平台">
                                    <div *ngIf="item.useVideoSystem">
                                        <ng-container *ngIf="item.status == 2">
                                            <ng-container *ngIf="item.website">
                                                <a href="{{item.website}}" target="_blank" class="bottom">進入</a>
                                            </ng-container>
                                            <ng-container *ngIf="!item.website">
                                                <a href="javascript:void(0)" class="bottom" (click)="VideoEvt(item)">進入</a>
                                            </ng-container>
                                        </ng-container>
                                        <ng-container *ngIf="item.status != 2">
                                            <a href="javascript:void(0)" class="bottom disabled">進入</a>
                                        </ng-container>
                                    </div>
                                    <div *ngIf="!item.useVideoSystem">
                                        <a href="javascript:void(0)" class="bottom disabled">此活動<br/>不開放</a>
                                    </div>
                                </td>
                            </tr>
                        </ng-container>
                    </table>
                </div>
            </ng-container>
        </ng-container>
        <empty *ngIf="!Data || Data.length == 0"></empty>
    </div>
</div>
